import { render } from "./App.vue?vue&type=template&id=3a5b8f9e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3a5b8f9e&lang=scss"
import "./App.vue?vue&type=style&index=1&id=3a5b8f9e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src88616841/src/scan_material_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5b8f9e"]])

export default __exports__